import {Pipe, PipeTransform} from "@angular/core";
import {format} from "d3-format";

let bytesFormat = format(".2s");

@Pipe({name: "bytes"})
export class BytesPipe implements PipeTransform {
	transform(value: number) {
		if (value == null)
			return null;

		return bytesFormat(value) + "B";
	}
}
